
export default function Services() {
  const services = [
    {
      icon: 'ri-map-2-line',
      title: '土地境界確定測量',
      description: '隣接地との境界を正確に確定し、境界標の設置を行います。土地売買や相続時に必要な重要な業務です。',
      features: ['現地測量', '境界標設置', '境界確認書作成', '立会い調整']
    },
    {
      icon: 'ri-building-line',
      title: '建物表題登記',
      description: '新築建物の登記や既存建物の変更登記を行います。建物の物理的状況を正確に登記簿に反映させます。',
      features: ['新築建物登記', '建物変更登記', '建物分割登記', '区分建物登記']
    },
    {
      icon: 'ri-scissors-cut-line',
      title: '土地分筆・合筆登記',
      description: '一筆の土地を複数に分割したり、複数の土地を一つにまとめる登記手続きを行います。',
      features: ['土地分筆登記', '土地合筆登記', '測量図作成', '登記申請']
    },
    {
      icon: 'ri-edit-line',
      title: '地積更正登記',
      description: '登記簿上の面積と実際の面積が異なる場合に、正しい面積に更正する登記を行います。',
      features: ['現況測量', '面積計算', '更正登記申請', '測量図作成']
    },
    {
      icon: 'ri-delete-bin-line',
      title: '建物滅失登記',
      description: '取り壊した建物や焼失した建物について、登記簿から削除する手続きを行います。',
      features: ['現地調査', '滅失証明', '登記申請', '完了証明']
    },
    {
      icon: 'ri-question-answer-line',
      title: '不動産登記相談',
      description: '不動産に関する登記手続きについて、専門的な観点からアドバイスを提供します。',
      features: ['登記相談', '手続き説明', '費用見積', '書類確認']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            サービス内容
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            大分県全域を中心に、土地・建物に関する測量・登記業務を幅広く承っております。
            お客様のニーズに合わせた最適なサービスを提供いたします。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-blue-600 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-xl p-8 shadow-lg">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">対応エリア</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">大分県全域</h4>
                <p className="text-gray-600">
                  大分市、別府市、中津市、日田市、佐伯市、臼杵市、津久見市、竹田市、豊後高田市、杵築市、宇佐市、豊後大野市、由布市、国東市、姫島村、日出町、九重町、玖珠町
                </p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-2-line text-2xl text-gray-600"></i>
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">近隣地域</h4>
                <p className="text-gray-600">
                  大分県に隣接する地域についても対応いたします。詳細な対応エリアについては、お気軽にお問い合わせください。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
